import { ArrowUpRight } from "lucide-react";
import { DSD_REVIEW_COPY } from "../copy";

/** 패널 맨 위 선택 셀 요약 — 섹션명, 축 라벨, 값, 표에서 보기 (Figma 7647-488899) */
export const DsdReviewSelectedCellCard = ({
  sectionName,
  axisLabel,
  value,
  onScrollToCell,
}: {
  sectionName: string;
  axisLabel?: string;
  value: string;
  onScrollToCell: () => void;
}) => (
  <div className="flex items-start justify-between gap-3 rounded-[8px] bg-background-neutral-alternative px-4 py-3">
    <div className="min-w-0">
      <p className="label-1-normal-semibold text-label-normal">{sectionName}</p>
      {axisLabel && (
        <p className="label-2-regular text-neutral-500">{axisLabel}</p>
      )}
      <p className="mt-1 truncate body-1-normal-semibold text-label-normal">
        {value || DSD_REVIEW_COPY.panel.emptyValue}
      </p>
    </div>
    <button
      type="button"
      onClick={onScrollToCell}
      aria-label={DSD_REVIEW_COPY.panel.scrollToCell}
      className="flex size-6 shrink-0 items-center justify-center rounded-small text-primary-color transition-colors hover:bg-decorate-neutral/6"
    >
      <ArrowUpRight className="size-6" />
    </button>
  </div>
);
